module.exports = __webpack_public_path__ + "908e4d2e/img/product-icon-grey.b248963c.svg";